import { useQuery } from '@hooks/reactQuery';

import { getAlarm } from '@api/alarmManagement';

import { extractQueryParams } from '@utils/common';

import { IAlarmManagement } from '@interfaces/alarms/alarm';
import { IAlarmByVendor } from '@interfaces/alarms/dto/alarmsDTO';

import { EVendorsValues } from '@enums/common';

import { ALARM_LIST } from '@constants/queryKeys';

interface IUseQueryAlarmsListLimenetReturn {
	isLoading: boolean;
	data: IAlarmManagement[];
	countOfRecords: number;
}

export const useQueryAlarmsListLimenet = (
	params: IAlarmByVendor,
): IUseQueryAlarmsListLimenetReturn => {
	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [ALARM_LIST, params],
		queryFn: extractQueryParams(getAlarm),
		enabled: [params.vendor === EVendorsValues.limenet],
		refetchOnWindowFocus: false,
	});

	return {
		isLoading: isInitialLoading,
		data: data?.items || [],
		countOfRecords: data?.count || 0,
	};
};
